import {
  BE_06,
  BLOG_ENTRY_DEFAULTS,
  hideBE06Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const BE06_PLASMIC_PROPS = {
  cards: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        image: {
          type: "imageUrl",
          defaultValue: "",
          description: "Image URL for the card",
        },
        imageAlt: {
          type: "string",
          defaultValue: "",
          description: "Alt text for the image",
        },
        title: {
          type: "string",
          defaultValue: "",
          description: "Heading text for the card",
        },
        description: {
          type: "string",
          defaultValue: "",
          description: "Description text for the card",
        },
        link: {
          type: "string",
          defaultValue: "",
          description: "Link URL for the card",
        },
      },
    },
    defaultValue: BLOG_ENTRY_DEFAULTS[BE_06].cards,
    description: "Cards array for BE06 variant",
    hidden: hideBE06Props,
  },
};
